//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { DayOfWeekEnum } from './Enums';

export class PracticeLogSettingsDisplayItem extends ItemBase {
    StartDay: DayOfWeekEnum = DayOfWeekEnum.Sunday;

    constructor(initializer?: Partial<PracticeLogSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogSettingsDisplayItem";
}
